// #region imports

// --- Angular
import { Component, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent {
  private readonly _defaultDiameter: Number = 120;

  @Input() avatar: string = '';
  @Input() diameter: Number = this._defaultDiameter;
}
